import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { PHONE_MASK } from '../../lib/helpers';
import { CartService } from '../cart.service';
import { PaySystem } from '../pay-system.service';
import { Delivery } from '../delivery.service';
import { RestComponent } from '../../lib/RestComponent';
import { NotificationService } from '../../notification.service';
import { ConsultService } from '../../consult.service';
import { OrderService } from '../order.service';
import { UserService } from '../../user.service';

@Component({
  selector: 'cart-checkout',
  templateUrl: './cart-checkout.component.html',
  styleUrls: ['./cart-checkout.component.less']
})
export class CartCheckoutComponent extends RestComponent implements OnInit {
  @Input() paySystems: PaySystem[];
  @Input() deliveries: Delivery[];
  paySystemId: string;
  deliveryId: string;
  name: string = '';
  lastName: string = '';
  phone: string = '';
  email: string = '';
  city: string = '';

  phoneMask = PHONE_MASK;

  constructor(
    private notificationService: NotificationService,
    public userService: UserService,
    private orderService: OrderService,
    private cartService: CartService,
    private consult: ConsultService,
    private router: Router,
  ) {
    super();
  }

  public ngOnInit() {
    if (this.paySystems.length > 0) this.paySystemId = this.paySystems[0].ID;
    if (this.deliveries.length > 0) this.deliveryId = this.deliveries[0].ID;
  }

  public async send(form: NgForm) {
    if (form.invalid) {
      return this.notificationService.show({
        message: 'Некорректно заполнены поля',
        status: 'danger'
      });
    }

    if (!this.paySystemId) {
      return this.notificationService.show({
        message: 'Выберите способ оплаты!',
        status: 'danger'
      });
    }

    if (!this.deliveryId) {
      return this.notificationService.show({
        message: 'Выберите способ доставки!',
        status: 'danger'
      });
    }

    this.loadingState = true;

    let data: object = {
      PAY_SYSTEM_ID: this.paySystemId,
      DELIVERY_ID: this.deliveryId,
      CITY: this.city
    };

    if (!this.userService.user) {
      data = Object.assign(data, {
        FIRST_NAME: this.name,
        LAST_NAME: this.lastName,
        PHONE_NUM: this.phone,
        EMAIL: this.email,
        ADDRESS: ''
      });
    }

    try {
      const res = await this.orderService.create(data);
      this.error = false;
      this.loadingState = false;
      this.resultMessage = res.message;
      this.consult.notification({
        name: this.resultMessage,
        status: 'success',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
      this.cartService.updateCart();
      this.orderService.orderSuccessMsg = this.resultMessage;
      this.router.navigate(['/cart/order-success']);
    } catch (e) {
      this.error = true;
      this.errorMessage = e.message;
      this.loadingState = false;
      this.consult.notification({
        name: this.errorMessage,
        status: 'danger',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
    }
  }
}
